export const formKeyDownHandler = (event: React.KeyboardEvent<HTMLDivElement>, onSubmit: () => Promise<void>): void => {
  if (event.key === 'Enter' || event.key === 'NumpadEnter') {
    event.preventDefault();
    event.stopPropagation();
    onSubmit();
  }
};
